export const CONTACT_DETAILS = [
  {
    id: 'phone',
    label: 'Call Us',
    value: '07462 911 383',
    href: 'tel:+447462911383',
    icon: 'phone',
  },
  {
    id: 'email',
    label: 'Email Us',
    value: 'hello@pavemend.co.uk',
    href: 'mailto:hello@pavemend.co.uk',
    icon: 'email',
  },
  {
    id: 'address',
    label: 'Visit Us',
    value: '77 Maidstone Rd, Foots Cray, Sidcup, DA14 5HB',
    href: 'https://maps.google.com/?q=77+Maidstone+Rd,+Foots+Cray,+Sidcup+DA14+5HB',
    icon: 'building',
  },
  {
    id: 'location',
    label: 'Serving',
    value: 'South East London & surrounding areas',
    icon: 'location',
  },
];
